module.exports = __webpack_public_path__ + "4692e0e66cfc5c447ada7704ae64fcdc.pdf";